/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type GetAdvancedPatientHistoryQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetAdvancedPatientHistoryQuery = {
  __typename?: 'Query'
  patientHistory: Array<
    | {
        __typename?: 'CommonPatientHistory'
        value?: Types.JSONObject | null
        entryID: string
        coachID?: string | null
        date?: string | null
        createdAt: Date
        source?: string | null
        type?: Types.PatientHistoryType | null
        files?: Array<{
          __typename?: 'PatientFile'
          fileID: string
          filename: string
          downloadURL?: string | null
          size: number
        }> | null
      }
    | {
        __typename?: 'FinancialEligibilityPatientHistory'
        description: string
        entryID: string
        coachID?: string | null
        date?: string | null
        createdAt: Date
        source?: string | null
        type?: Types.PatientHistoryType | null
        costEstimate?: {
          __typename?: 'FinancialEligibilityCostEstimate'
          intakeCostEstimateInCents: number
          month1CostEstimateInCents: number
          month2CostEstimateInCents: number
          month3CostEstimateInCents: number
        } | null
        files?: Array<{
          __typename?: 'PatientFile'
          fileID: string
          filename: string
          downloadURL?: string | null
          size: number
        }> | null
      }
    | {
        __typename?: 'LabOrderPatientHistory'
        entryID: string
        coachID?: string | null
        date?: string | null
        createdAt: Date
        source?: string | null
        type?: Types.PatientHistoryType | null
        labOrder?: { __typename?: 'LabOrder'; orderID: string } | null
        files?: Array<{
          __typename?: 'PatientFile'
          fileID: string
          filename: string
          downloadURL?: string | null
          size: number
        }> | null
      }
    | {
        __typename?: 'VideoCallPatientHistory'
        value?: Types.JSONObject | null
        entryID: string
        coachID?: string | null
        date?: string | null
        createdAt: Date
        source?: string | null
        type?: Types.PatientHistoryType | null
        videoCall: {
          __typename?: 'VideoCall'
          id: string
          reason?: Types.ScheduledVideoCallReason | null
          activeDurationInMS?: number | null
          numberOfParticipants?: number | null
        }
        files?: Array<{
          __typename?: 'PatientFile'
          fileID: string
          filename: string
          downloadURL?: string | null
          size: number
        }> | null
      }
  >
}

export const GetAdvancedPatientHistoryDocument = gql`
  query getAdvancedPatientHistory($uid: ID!) {
    patientHistory(uid: $uid, orderBy: date_DESC) {
      entryID
      coachID
      date
      createdAt
      source
      type
      files {
        fileID
        filename
        downloadURL
        size
      }
      ... on CommonPatientHistory {
        value
      }
      ... on VideoCallPatientHistory {
        value
        videoCall {
          id
          reason
          activeDurationInMS
          numberOfParticipants
        }
      }
      ... on FinancialEligibilityPatientHistory {
        description
        costEstimate {
          intakeCostEstimateInCents
          month1CostEstimateInCents
          month2CostEstimateInCents
          month3CostEstimateInCents
        }
      }
      ... on LabOrderPatientHistory {
        labOrder {
          orderID
        }
      }
    }
  }
`

/**
 * __useGetAdvancedPatientHistoryQuery__
 *
 * To run a query within a React component, call `useGetAdvancedPatientHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedPatientHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedPatientHistoryQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetAdvancedPatientHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<GetAdvancedPatientHistoryQuery, GetAdvancedPatientHistoryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedPatientHistoryQuery, GetAdvancedPatientHistoryQueryVariables>(
    GetAdvancedPatientHistoryDocument,
    options
  )
}
export function useGetAdvancedPatientHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdvancedPatientHistoryQuery, GetAdvancedPatientHistoryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedPatientHistoryQuery, GetAdvancedPatientHistoryQueryVariables>(
    GetAdvancedPatientHistoryDocument,
    options
  )
}
export type GetAdvancedPatientHistoryQueryHookResult = ReturnType<typeof useGetAdvancedPatientHistoryQuery>
export type GetAdvancedPatientHistoryLazyQueryHookResult = ReturnType<typeof useGetAdvancedPatientHistoryLazyQuery>
export type GetAdvancedPatientHistoryQueryResult = Apollo.QueryResult<
  GetAdvancedPatientHistoryQuery,
  GetAdvancedPatientHistoryQueryVariables
>
